// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2zQGt","footer":"ModalFilter_footer__3ex7S"};